import React, { useState, useEffect, useCallback } from "react";
import { format } from "date-fns";
import LoadingButton from "../Loading button/LoadingButton";
import "./CreateAccountDetailsStyle.css";
import { getAccountCategoryFromFip } from "../../utils/fipUtils";
import { getDefaultFiConfigFromFip } from "../../utils/fipUtils";
import { getFipIdByKey } from "../../utils/fipUtils";

const FI_TYPES_WITH_REBIT_SCHEMA_VERSION = [
  "DEPOSIT",
  "RECURRING_DEPOSIT",
  "TERM_DEPOSIT",
];

const shouldIncludeRebitSchemaVersion = (fiType) =>
  FI_TYPES_WITH_REBIT_SCHEMA_VERSION.includes(fiType);

const CreateAccountDetails = () => {
  const accountDetails = [
    {
      name: "Banking",
      id: "DEPOSIT",
      values: ["SAVINGS", "CURRENT"],
    },
    {
      name: "Banking",
      id: "TERM_DEPOSIT",
      values: "DEFAULT",
    },
    {
      name: "Banking",
      id: "RECURRING_DEPOSIT",
      values: "DEFAULT",
    },
    {
      name: "Insurance",
      id: "LIFE_INSURANCE",
      values: "DEFAULT",
    },
    {
      name: "Insurance",
      id: "INSURANCE_POLICIES",
      values: "DEFAULT",
    },
    {
      name: "InsurancePolicies",
      id: "INSURANCE_POLICIES",
      values: "DEFAULT",
    },
    {
      name: "GeneralInsurance",
      id: "GENERAL_INSURANCE",
      values: "DEFAULT",
    },
    {
      name: "LifeInsurance",
      id: "LIFE_INSURANCE",
      values: "DEFAULT",
    },
    {
      name: "General_Insurance",
      id: "GENERAL_INSURANCE",
      values: "DEFAULT",
    },
    {
      name: "General_Insurance",
      id: "INSURANCE_POLICIES",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "EQUITIES",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "MUTUAL_FUNDS",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "IDR",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "CIS",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "ETF",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "AIF",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "NPS",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "SIP",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "INVIT",
      values: "DEFAULT",
    },
    {
      name: "Eq&Mf",
      id: "REIT",
      values: "DEFAULT",
    },
    {
      name: "Gst",
      id: "GSTR1_3B",
      values: "DEFAULT",
    },
    {
      name: "mfc",
      id: "MFC_MF",
      values: "DEFAULT",
    }
  ];

  let [formData, setFormData] = useState({
    contactNumber: "",
    fipId: "",
    fiType: "",
    accountType: "",
    rebitSchemaVersion: "",
    birthDate: format(
      new Date(1966,5,8),
      "yyyy-MM-dd"
    ),
    startDate: format(
      new Date().setFullYear(new Date().getFullYear() - 1),
      "yyyy-MM-dd"
    ),
    endDate: format(new Date(), "yyyy-MM-dd"),
  });

const getNameFromAccountDetails = (fipId) => {
  return getAccountCategoryFromFip(fipId);
};

  const fiTypeList = (fipId) => {
    const filteredOptions = accountDetails
      .filter((item) => item.name === getNameFromAccountDetails(fipId))
      .map((item) => item.id);
    return filteredOptions;
  };

  const accountTypeList = (fipId, fiType) => {
    const filteredOption = accountDetails.find((item) => item.id === fiType && item.name === getNameFromAccountDetails(fipId));
    if (filteredOption) {
      return Array.isArray(filteredOption.values) ? filteredOption.values : [filteredOption.values];
    }
    return [];
  };

  function handleFiTypeChange(event) {
    const fiType = event.target.value;
    let act;
    if (fiType === "DEPOSIT") act = "SAVINGS";
    else act = "DEFAULT";
    setFormData((data) => ({
      ...data,
      accountType: act,
      rebitSchemaVersion: shouldIncludeRebitSchemaVersion(fiType) ? "v2" : "",
      fiType,
      startDate: format(
        new Date().setFullYear(new Date().getFullYear() - 1),
        "yyyy-MM-dd"
      ),
      endDate: format(new Date(), "yyyy-MM-dd"),
    }));
  }

const onFipChange = (event) => {
  const fipId = event.target.value;
  const { fiType, accountType } = getDefaultFiConfigFromFip(fipId);

  setFormData((data) => ({
    ...data,
    [event.target.name]: fipId,
    fiType,
    accountType,
    rebitSchemaVersion: shouldIncludeRebitSchemaVersion(fiType) ? "v2" : ""
  }));
};

  const onFormSubmit = (event) => {
    setFormData((data) => ({
      ...data,
      [event.target.name]: event.target.value,
    }));
  };

  let [errorMessage, setErrorMessage] = useState({});
  let [successMessage, setSuccessMessage] = useState();
  let [isSubmit, setIsSubmit] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage(validate(formData));
    setIsSubmit(true);
  };

  const validate = (formData) => {
    const errors = {};
    if (!/^([1-9]{1}[0-9]{9})$/.test(formData.contactNumber))
      errors.contactNumber = "Please enter a valid 10-digit Mobile Number!";
    if (!formData.fipId) errors.fipId = "Please select a Dummy Bank!";
    if (formData.startDate > formData.endDate)
      errors.transactionDates = "'From' Date should be before 'To' Date!";
    if ((formData.fiType === "LIFE_INSURANCE" || formData.fiType === "INSURANCE_POLICIES" || formData.fiType === "GENERAL_INSURANCE") && !formData.birthDate) errors.birthDate = "Please enter valid Birth Date!";
    return errors;
  };

  const [isResponseLoading, setIsResponseLoading] = useState(false);

const addAccount = useCallback(async () => {
  const hostname = window.location.hostname;
  await fetch(
    `https://${hostname}/ConnectHub/AccountManagement/Account`,
    {
      method: "POST",
      body: JSON.stringify({
        startDate: formData.startDate,
        endDate: formData.endDate,
        fipId: formData.fipId,
        fiType: formData.fiType,
        accountType: formData.accountType,
        ...(shouldIncludeRebitSchemaVersion(formData.fiType) && {
          rebitSchemaVersion: formData.rebitSchemaVersion,
        }),
        identifiers: {
          MOBILE: formData.contactNumber,
          AADHAR: "679486011333",
          EMAIL: "info@cookiejar.in",
          DOB: formData.birthDate
        }
      }),
      headers: {
        Accept: "application/json; charset=UTF-8",
        "Content-Type": "application/json; charset=UTF-8",
      },
    }
  )
    .then((response) => {
      setIsResponseLoading(false);
      return response.json();
    })
    .then((data) => {
      setSuccessMessage(
        "Account successfully created for mobile number: " +
          formData.contactNumber +
          " with account number: " +
          data["accountNo"]
      );
    });
}, [formData]);

   useEffect(() => {
     if (Object.keys(errorMessage).length === 0 && isSubmit) {
       setIsResponseLoading(true);
       setIsSubmit(false);
       addAccount();
     }
   }, [errorMessage, isSubmit, addAccount]);

  return (
    <>
      <form onSubmit={(e) => handleFormSubmit(e)}>
        <div className="contactNumber">
          <label htmlFor="contactNumber">
            <b>Mobile Number:</b>
          </label>
          <input
            type="text"
            placeholder="Mobile Number"
            name="contactNumber"
            id="contactNumber"
            onChange={(e) => onFormSubmit(e)}
          />
        </div>
        {!/^([1-9]{1}[0-9]{9})$/.test(formData.contactNumber) && (
          <span style={{ fontSize: 14, color: "red" }}>
            {errorMessage.contactNumber}
          </span>
        )}
        <hr />
        <div className="accountData">
          <label htmlFor="dummyBank">
            <b>Dummy Bank</b>
          </label>
          <p style={{ fontSize: 11, color: "#212529" }}>
            (Select a dummy bank to create an account with)
          </p>
          <div className="fipDetails">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("FINVU_BANK")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Finvu Bank(Bank Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("DHANAGAR_BANK")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Dhanagar Bank(Bank Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("FINSURE")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Finsure(Life Insurance Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("FINSURE_GENERAL")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Finsure General(General Insurance Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("FINREPO")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Finrepo(Demat Accounts/RTA Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("INSPOL")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">FIP insurance policies(Insurance Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("GENERAL_INSURANCE")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">General Insurance FIP(General Insurance Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("LIFE_INSURANCE")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Life Insurance FIP(Life Insurance Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("GST")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">Finvu GSTN(GST Accounts)</label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="fipId"
                id="fipId"
                defaultValue={getFipIdByKey("MFC")}
                onClick={(e) => onFipChange(e)}
              />
              <label className="form-check-label">MFC(MFC Accounts)</label>
            </div>

          </div>
          {!formData.fipId && (
            <span style={{ fontSize: 14, color: "red" }}>
              {errorMessage.fipId}
            </span>
          )}
          <div className="accountDetails" id="accountDetails">
            {formData.fipId && (
              <>
                <hr />
                <label htmlFor="dummyBank" style={{ marginBottom: '5px' }}>
                  <b>Account Details</b>
                </label>
                <div className="accDetails">
                  <div>
                    <label htmlFor="fiType">
                      <b>FI type:</b>
                    </label>
                    <select
                      name="fiType"
                      id="fiType"
                      value={formData.fiType}
                      onChange={(e) => {
                        handleFiTypeChange(e);
                      }}
                    >
                      {fiTypeList(formData.fipId).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label htmlFor="accountType">
                      <b>Account type:</b>
                    </label>
                    <select
                      name="accountType"
                      id="accountType"
                      value={formData.accountType}
                      onChange={(e) => {
                        onFormSubmit(e);
                      }}
                    >
                      {accountTypeList(formData.fipId, formData.fiType).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>

                  {shouldIncludeRebitSchemaVersion(formData.fiType) && (
                    <div>
                      <label htmlFor="rebitSchemaVersion">
                        <b>Rebit Schema Version:</b>
                      </label>
                      <select
                        name="rebitSchemaVersion"
                        id="rebitSchemaVersion"
                        value={formData.rebitSchemaVersion}
                        onChange={(e) => onFormSubmit(e)}
                      >
                        <option value="v2">v2</option>
                        <option value="v1">v1</option>
                      </select>
                      {errorMessage.rebitSchemaVersion && (
                        <span style={{ fontSize: 14, color: "red" }}>
                          {errorMessage.rebitSchemaVersion}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <hr />
        {formData.fipId && (formData.fiType === "LIFE_INSURANCE" || formData.fiType === "INSURANCE_POLICIES" || formData.fiType === "GENERAL_INSURANCE") && (
          <>
            <div className="birthDate">
              <label htmlFor="birthDate">
                <b>Personal Information</b>
              </label>
              {(
                <div>
                  <label htmlFor="birthDate">
                    <b>Birth Date:</b>
                  </label>
                  <input
                    type="date"
                    name="birthDate"
                    id="birthDate"
                    value={formData.birthDate}
                    onChange={(e) => onFormSubmit(e)}
                  />
                </div>
              )}

            </div>
            {formData.birthDate === "" && (
              <span style={{ fontSize: 14, color: "red" }}>
                {errorMessage.birthDate}
              </span>
            )}
            <hr />
          </>
        )}

        {formData.fipId && (formData.fiType === "DEPOSIT" || formData.fiType === "RECURRING_DEPOSIT" || formData.fiType === "EQUITIES" || formData.fiType === "MUTUAL_FUNDS" || formData.fiType === "ETF") && (
          <>
            <div className="transactionDates">
              <label htmlFor="transactionDates">
                <b>Generate Transactions</b>
              </label>
              {(formData.fiType === "DEPOSIT"|| formData.fiType === "EQUITIES" ||  formData.fiType === "MUTUAL_FUNDS" || formData.fiType === "ETF" )&& (
                <div>
                  <label htmlFor="startDate">
                    <b>From:</b>
                  </label>
                  <input
                    type="date"
                    name="startDate"
                    id="startDate"
                    value={formData.startDate}
                    onChange={(e) => onFormSubmit(e)}
                  />
                  <label htmlFor="endDate">
                    <b>To:</b>
                  </label>
                  <input
                    type="date"
                    name="endDate"
                    id="endDate"
                    value={formData.endDate}
                    onChange={(e) => onFormSubmit(e)}
                  />
                </div>
              )}
              {formData.fiType === "RECURRING_DEPOSIT" && (
                <div>
                  <label htmlFor="endDate">
                    <b>From:</b>
                  </label>
                  <input
                    type="date"
                    name="endDate"
                    id="endDate"
                    value={formData.endDate}
                    onChange={(e) => onFormSubmit(e)}
                  />
                  <label htmlFor="startDate">
                    <b>For:</b>
                  </label>
                  <select
                    name="startDate"
                    id="startDateRD"
                    onChange={(e) => onFormSubmit(e)}
                  >
                    <option
                      value={format(
                        new Date().setFullYear(new Date().getFullYear() - 1),
                        "yyyy-MM-dd"
                      )}
                    >
                      1 Year
                    </option>
                    <option
                      value={format(
                        new Date().setFullYear(new Date().getFullYear() - 2),
                        "yyyy-MM-dd"
                      )}
                    >
                      2 Year
                    </option>
                    <option
                      value={format(
                        new Date().setFullYear(new Date().getFullYear() - 3),
                        "yyyy-MM-dd"
                      )}
                    >
                      3 Year
                    </option>
                  </select>
                </div>
              )}
            </div>
            {formData.startDate > formData.endDate && (
              <span style={{ fontSize: 14, color: "red" }}>
                {errorMessage.transactionDates}
              </span>
            )}
            <hr />
          </>
        )}
        <LoadingButton
          btnTitle="Create Account"
          isLoading={isResponseLoading}
          onClick={(e) => {
            handleFormSubmit(e);
          }}
        />
        <div id="manageAccounts">
          Already have an account?{" "}
          <a href="/manage-accounts">Manage accounts</a>
        </div>
      </form>
      <span style={{ fontSize: 18, color: "green" }}>{successMessage}</span>
    </>
  );
};

export default CreateAccountDetails;
